export default "__VITE_ASSET__Gu8$EAYw__"